import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geschenk2',
  templateUrl: './geschenk2.component.html',
  styleUrls: ['./geschenk2.component.scss']
})
export class Geschenk2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
